import configuration from "../config";
import axios from "./axiosConfiguration";

const endpoint = `${configuration.api_url}rituel`;

export const getRituals = () => {
    return axios
        .get(endpoint)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const getRitualsByMonthByEnterprise = (year, month) => {
    return axios
        .get(`${endpoint}/by-enterprise/${year}/${month}`)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};


export const saveRitual = async (data) => {
    return axios
        .post(`${endpoint}`, data)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const deleteRitual = async (blocId) => {
    return axios
        .delete(`${endpoint}/${blocId}`)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};


export const createRitualGoogleSheet = async (ritualId) => {
    return axios
        .get(`${endpoint}/create-google-sheet/${ritualId}`)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const checkExistingRitual = async (ritualId, buId, year, month) => {
    return axios
        .get(`${endpoint}/check-existing/${ritualId}/${buId}/${year}/${month}`)
        .then((response) => {
            return Promise.resolve(response.data);
        })
        .catch((error) => {
            return Promise.reject(error);
        });
};

export const checkFollowUpText = async (ritualId, buId) => {
  return axios
    .get(`${endpoint}/check-follow-up-text/${ritualId}/${buId}`)
    .then((response) => {
      return Promise.resolve(response.data);
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
